import { render, staticRenderFns } from "./BackgroundChecksTable.vue?vue&type=template&id=332efc27&scoped=true&lang=pug"
import script from "./BackgroundChecksTable.vue?vue&type=script&lang=ts"
export * from "./BackgroundChecksTable.vue?vue&type=script&lang=ts"
import style0 from "./BackgroundChecksTable.vue?vue&type=style&index=0&id=332efc27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332efc27",
  null
  
)

export default component.exports